'use strict';

const logout = [
  '$window',
  'session',
  'admin',
  'analytics',

  function ($window, session, admin, analytics) {
    return function logout() {
      session.destroy();
      admin.deleteCookie();
      analytics.reset();

      $window.location.href = '/';
    };
  }
];

export default logout;



// WEBPACK FOOTER //
// ./app/src/services/logout.js